var _objectSpread = require("/home/runner/work/DaizeLellys-ingles/DaizeLellys-ingles/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _classCallCheck = require("/home/runner/work/DaizeLellys-ingles/DaizeLellys-ingles/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/runner/work/DaizeLellys-ingles/DaizeLellys-ingles/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/home/runner/work/DaizeLellys-ingles/DaizeLellys-ingles/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/runner/work/DaizeLellys-ingles/DaizeLellys-ingles/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/home/runner/work/DaizeLellys-ingles/DaizeLellys-ingles/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _assertThisInitialized = require("/home/runner/work/DaizeLellys-ingles/DaizeLellys-ingles/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};
var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var Preview_exports = {};
__export(Preview_exports, {
  default: function _default() {
    return Preview;
  }
});
module.exports = __toCommonJS(Preview_exports);
var import_react = __toESM(require("react"));
var ICON_SIZE = "64px";
var cache = {};
var Preview = /*#__PURE__*/function (_import_react$Compone) {
  "use strict";

  _inherits(Preview, _import_react$Compone);
  function Preview() {
    var _this;
    _classCallCheck(this, Preview);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Preview).apply(this, arguments));
    __publicField(_assertThisInitialized(_assertThisInitialized(_this)), "mounted", false);
    __publicField(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      image: null
    });
    __publicField(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyPress", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        _this.props.onClick();
      }
    });
    return _this;
  }
  _createClass(Preview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.fetchImage(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        url = _this$props.url,
        light = _this$props.light;
      if (prevProps.url !== url || prevProps.light !== light) {
        this.fetchImage(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "fetchImage",
    value: function fetchImage(_ref) {
      var _this2 = this;
      var url = _ref.url,
        light = _ref.light,
        oEmbedUrl = _ref.oEmbedUrl;
      if (import_react.default.isValidElement(light)) {
        return;
      }
      if (typeof light === "string") {
        this.setState({
          image: light
        });
        return;
      }
      if (cache[url]) {
        this.setState({
          image: cache[url]
        });
        return;
      }
      this.setState({
        image: null
      });
      return window.fetch(oEmbedUrl.replace("{url}", url)).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.thumbnail_url && _this2.mounted) {
          var image = data.thumbnail_url.replace("height=100", "height=480").replace("-d_295x166", "-d_640");
          _this2.setState({
            image: image
          });
          cache[url] = image;
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        light = _this$props2.light,
        onClick = _this$props2.onClick,
        playIcon = _this$props2.playIcon,
        previewTabIndex = _this$props2.previewTabIndex,
        previewAriaLabel = _this$props2.previewAriaLabel;
      var image = this.state.image;
      var isElement = import_react.default.isValidElement(light);
      var flexCenter = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      };
      var styles = {
        preview: _objectSpread({
          width: "100%",
          height: "100%",
          backgroundImage: image && !isElement ? "url(".concat(image, ")") : void 0,
          backgroundSize: "cover",
          backgroundPosition: "center",
          cursor: "pointer"
        }, flexCenter),
        shadow: _objectSpread({
          background: "radial-gradient(rgb(0, 0, 0, 0.3), rgba(0, 0, 0, 0) 60%)",
          borderRadius: ICON_SIZE,
          width: ICON_SIZE,
          height: ICON_SIZE,
          position: isElement ? "absolute" : void 0
        }, flexCenter),
        playIcon: {
          borderStyle: "solid",
          borderWidth: "16px 0 16px 26px",
          borderColor: "transparent transparent transparent white",
          marginLeft: "7px"
        }
      };
      var defaultPlayIcon = /* @__PURE__ */import_react.default.createElement("div", {
        style: styles.shadow,
        className: "react-player__shadow"
      }, /* @__PURE__ */import_react.default.createElement("div", {
        style: styles.playIcon,
        className: "react-player__play-icon"
      }));
      return /* @__PURE__ */import_react.default.createElement("div", _objectSpread({
        style: styles.preview,
        className: "react-player__preview",
        onClick: onClick,
        tabIndex: previewTabIndex,
        onKeyPress: this.handleKeyPress
      }, previewAriaLabel ? {
        "aria-label": previewAriaLabel
      } : {}), isElement ? light : null, playIcon || defaultPlayIcon);
    }
  }]);
  return Preview;
}(import_react.Component);